import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import localforage from "localforage";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CustomTable from "../../../components/CustomTable";
import { filterList } from "../../../libs/utils";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import { editPPO, getPPOById, getPPOList } from "../../../services/ppo";

function ListPartnerPromotionalOffers() {
  const [rows, setRows] = useState();
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [isDynamicTable, setIsDynamicTable] = useState(false);

  const columns = [
    {
      id: "offerName",
      label: "Offer Name",
      minWidth: 100,
      align: "left",
      enableSort: true,
    },
    {
      id: "title",
      label: "Title",
      minWidth: 200,
      align: "left",
      enableSort: true,
    },
    {
      id: "partnerName",
      label: "Partner Name",
      minWidth: 200,
      align: "center",
      enableSort: true,
    },
    {
      id: "priority",
      label: "Priority",
      minWidth: 200,
      align: "center",
      enableSort: true,
    },
    {
      id: "active",
      label: "Active",
      minWidth: 200,
      align: "center",
    },

    {
      id: "Action",
      label: "Action",
      minWidth: 100,
      align: "center",
    },
  ];

  const setPPOActiveStatus = (id, checked) => {
    setRows((prev) => {
      return prev.map((d) => {
        if (d.id !== id) {
          return d;
        } else {
          return {
            ...d,
            active: (
              <Switch
                checked={checked}
                onChange={(e) => setPPOActiveStatus(d.id, e.target.checked)}
                inputProps={{ "aria-label": "controlled" }}
              />
            ),
          };
        }
      });
    });
    getPPOById(id)
      .then((response) => {
        let data = {
          partnerName: response.partnerName,
          offerId: response.offerId,
          offerName: response.offerName,
          title: response.title,
          subTitle: response.subTitle,
          clickUrl: response.clickUrl,
          imageUrl: response.imageUrl,
          desktopImageUrl: response.desktopImageUrl,
          priority: response.priority,
        };
        data.active = checked;
        editPPO(id, data)
          .then((response) => {})
          .catch((error) => {
            throw error;
          });
      })
      .catch(function (error) {
        throw error;
      });
  };

  const setDynamicTable = (parentWidth, tableWidth) => {
    setIsDynamicTable(true);
  };

  const searchData = (e) => {
    setSearchKey(e.target.value);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dataGenerator = (d) => {
    return {
      id: d.id,
      offerName: d.offerName,
      title: d.title,
      partnerName: d.partnerName,
      priority: d.priority,
      active: (
        <Switch
          checked={d.active}
          onChange={(e) => setPPOActiveStatus(d.id, e.target.checked)}
          inputProps={{ "aria-label": "controlled" }}
        />
      ),
      Action: (
        <Link
          to={`/app/partner-promotional-offer/${d.id}`}
          style={{ textDecoration: "none" }}
        >
          <Button variant="contained" size="small" color="warning">
            Edit
          </Button>
        </Link>
      ),
    };
  };

  useEffect(() => {
    setLoading(true);
    localforage.getItem("@ppo", (error, data) => {
      if (data) {
        if (data?.length > 0 && typeof data === "object") {
          setRows(data.map((d) => dataGenerator(d)));
        } else {
          setRows([]);
        }
      }
    });
    getPPOList()
      .then((response) => {
        setLoading(false);
        if (response?.length > 0 && typeof response === "object") {
          setRows(response.map((d) => dataGenerator(d)));
        } else {
          setRows([]);
        }
        localforage.setItem("@ppo", response, (error, data) => {
          if (error) {
            throw error;
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        throw error;
      });
  }, []);

  return (
    <>
      <Box
        sx={{ px: 6 }}
        className={`main-box ${isDynamicTable ? "dynamicTableStyle" : ""}`}
      >
        <div
          className={`bankAddRuleHeader mb-3 ${
            isDynamicTable ? "listHeaderPaddingRight" : ""
          }`}
        >
          <div
            style={{
              display: "flex",
              padding: "1.5rem 0",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "#33343a" }} variant="h4" component="h4">
              Partner Promotional Offers
            </Typography>
            {loading && (
              <div
                style={{
                  marginLeft: "12px",
                  color: "#a0a0a0",
                  fontSize: "24px",
                }}
              >
                <i
                  className={`fa fa-refresh ${
                    loading === true ? "fa-spin" : ""
                  }`}
                  aria-hidden="true"
                ></i>
              </div>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "end" }}>
            <TextField
              id="standard-basic"
              label="Search"
              variant="standard"
              sx={{ mr: 1 }}
              onKeyUp={(e) => searchData(e)}
              InputProps={{
                endAdornment: <SearchIcon sx={{ color: "#8a8a8a" }} />,
              }}
            />

            <Tooltip title="Choose Option">
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <MoreVertIcon sx={{ width: 32, height: 32 }} />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem
                sx={{
                  "&:hover": {
                    background: "#f9da8792",
                    color: "#000",
                  },
                }}
              >
                <Link
                  to="/app/partner-promotional-offer/0"
                  style={{ color: "#040721" }}
                >
                  Add New Partner Promotional Offers
                </Link>
              </MenuItem>
            </Menu>
          </div>
        </div>

        <CustomTable
          setDynamicTable={setDynamicTable}
          data={filterList(rows, searchKey) || []}
          columns={columns}
        />
      </Box>
    </>
  );
}

export default ListPartnerPromotionalOffers;
